module.exports = __webpack_public_path__ + "img/character_lineup_front_002.136d1092.jpg";